/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';

export default Construct.extend(
    {
        cache: {},

        request: function(options, useCache) {
            let cacheKey = useCache ? this.getCacheKey(options) : null;
            let cache = cacheKey ? this.cache[cacheKey] : null;

            if (cache) {
                return this.getCache(cache);
            } else {
                return can
                    .ajax(options)
                    .always(
                        (data, status) =>
                            cacheKey && this.setCache(cacheKey, data, status),
                    );
            }
        },

        getCacheKey: function(options) {
            return JSON.stringify(options);
        },

        setCache: function(cacheKey, data, status) {
            if (status !== 'error') {
                this.cache[cacheKey] = {
                    status: status,
                    data: data,
                };
            }
        },

        getCache: function(cache) {
            return can.Deferred().resolve(cache.data, cache.status);
        },
    },
    {
        /* */
    },
);
